import {
  Button,
  Dialog,
  DisabledContext,
  Field,
  Input,
  Modal,
  RadioButton,
  Select,
  Spacer,
  Text,
} from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { QueryForm } from 'client/views/query/query-form/query-form';
import { getQueryTemplateOptions } from 'client/views/query/query-utils';
import { IAnalytic } from 'common/interfaces/analytics';
import { IQuery } from 'common/interfaces/query';
import { noop } from 'es-toolkit';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type AnalyticModalProps = {
  visible: boolean;
  onClose: () => void;
  queries: IQuery[];
  itemForEdit: IAnalytic | null;
  onSubmit: (analytic: { queryid: string; analyticid?: string; name: string; }) => void;
};

const queryOptionsTypes = {
  existing: 'existing',
  new: 'new',
};

const queryRadionButtonOptions = [
  {
    label: 'Existing query',
    value: queryOptionsTypes.existing,
  },
  // {
  //   label: 'New query',
  //   value: queryOptionsTypes.new,
  // },
];

export const AnalyticModal = ({
  visible,
  onClose,
  queries,
  itemForEdit,
  onSubmit,
}: AnalyticModalProps) => {
  const { t } = useTranslation();
  const queriesOptions = getQueryTemplateOptions(queries ?? [], t);
  const [selectedQueryId, setSelectedQuery] = useState<string | null>(null);
  const [analyticName, setAnalyticName] = useState<string>('');
  const [selectedQueryType, setSelectedQueryType] = useState<{ label: string; value: string; } | null>(queryRadionButtonOptions[0]);
  const selectedOption = queriesOptions.find(n => n.value === selectedQueryId);
  const selectedQuery = queries.find(query => query.queryid === selectedQueryId);

  useEffect(() => {
    if (itemForEdit?.query?.queryid) {
      setSelectedQuery(itemForEdit.query.queryid);
      setAnalyticName(itemForEdit.name);
    }
  }, [itemForEdit?.analyticid]);

  const handleSubmit = () => {
    if (!selectedQueryId) {
      return;
    }
    if (itemForEdit?.query?.queryid) {
      const updatedQuery = {
        ...itemForEdit,
        name: analyticName,
        query: queries.find(i => i.queryid === selectedQueryId),
        queryid: selectedQueryId,
      };
      onSubmit(updatedQuery);
    } else {
      onSubmit({ queryid: selectedQueryId, name: analyticName });
    }
  };

  const content = (
    <>
      <Field>
        <Text bold>{t(translations.name)}</Text>
        <Spacer height="var(--padding-xxs)" />
        <Input value={analyticName} onChange={(e) => setAnalyticName(e.target.value)} />
      </Field>
      <Field>
        <RadioButton
          inline
          onChange={(e) => {
            const { value } = e.target;
            if (value !== selectedQueryType) {
              const newOption = queryRadionButtonOptions.find(i => i.value === value);
              if (newOption) {
                setSelectedQueryType(newOption);
              }
            }
          }}
          options={queryRadionButtonOptions}
          value={selectedQueryType!}
        />
      </Field>

      <Field
        label={t(translations.query_queryName)}
      >
        <Select
          onChange={(e: any) => {
            setSelectedQuery(e.target.value);
          }}
          value={selectedOption}
          options={queriesOptions}
          placeholder={t(translations.query_selectQuery)}
        />
      </Field>
      {selectedQueryId
        && (
          <DisabledContext.Provider value>
            <QueryForm selectedQuery={selectedQuery} setSelectedQuery={noop} isAnalyticPage />
          </DisabledContext.Provider>
        )}
    </>
  );

  return (
    <Modal visible={visible} centered onEscape={onClose}>
      <Dialog
        dialog={{
          scroll: true,
          heading: 'Analytics',
          content,
          footer: (
            <>
              <Button
                label={t(translations.save)}
                onClick={handleSubmit}
                disabled={!analyticName || !selectedQueryId}
              />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
          width: '30%',
        }}
      />
    </Modal>
  );
};